import { render, staticRenderFns } from "./BarCard.vue?vue&type=template&id=52e6964b"
import script from "./BarCard.vue?vue&type=script&lang=js"
export * from "./BarCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports